import React from "react";
import {Checkbox, FormControlLabel} from "@material-ui/core";
import "./GeoScale.scss";

function GeoScale(props) {
  const { geoScaled, onToggle } = props;

  return (
    <div className="geoScale">
      <FormControlLabel
        control={<Checkbox checked={Boolean(geoScaled)} onChange={onToggle} name="checkedGeo" />}
        label="Scale data for selected geography"
      />
    </div>
  );
}

export default GeoScale;
